import React from 'react';
import { Button } from '@mui/material';

/**
 * A React component that renders a standalone button with a specific design.
 * 
 * @param {Object} props - The component props.
 * @param {string} [props.text] - The text to display on the button.
 * @param {string} [props.color='primary'] - The button color.
 * @param {Function} props.onClick - The callback function to call when the button is clicked.
 * @param {boolean} [props.selected=false] - Whether the button is currently selected.
 */
const BntAdha6Slots = ({
  text,
  color = 'primary',
  onClick,
  selected = false
}) => {
  return (
   <Button
  size="large"
  variant={selected ? 'contained' : 'outlined'}
  color={color}
  onClick={onClick}
    sx={{
   width: { xs: '90%', sm: '100px', md: '150px' },
    height: '40px',
    fontSize: { xs: '14px', sm: '15px', md: '16px' },
    padding: '8px 10px',
    textTransform: 'none',
    borderWidth: selected ? 2 : 1,
    borderColor: selected ? '#2B8CB9' : 'rgba(0,0,0,0.23)',
     backgroundImage: selected ?'linear-gradient(45deg, #064D6F 0%, #2b8cb9 51%, #1BB2F8 100%)': 'none',
          cursor: 'pointer',
          userSelect: 'none',
          '&:hover': {
            backgroundPosition: 'right center',
            color: '#fff',
            textDecoration: 'none'
          },
          '&:active': {
            transform: 'scale(0.95)'
          }
  }}
>
  {text || 'ADHA – 6 slots'}
</Button>

  );
};

export default BntAdha6Slots;
